module.exports = __webpack_public_path__ + "img/20251121_anniversary.3902f9e5.jpg";